import styles from './basketball.module.css'
import PersonCard from '../../../components/PersonCard/PersonCard';
import { basketballTeams } from '../../../../config/mannschaftssport_teams';
import TeamCard from '../../../components/TeamCard/TeamCard';
import { useState, useEffect } from "react";
import NewsCard from '../../Startseite/NewsCarousel/NewsCard';
import { useNavigate } from "react-router-dom";
import NoNews from '../../../components/Error/NoNews/NoNews';
import { loadAssignmentsByArea } from '../../../../code/AssignmentPersons';
function Basketball() {
    const [article, setArticle] = useState(null);
    const [persons, setPersons] = useState([]);
    const color = '--color-red';
    const colorText = '--main-color-white';
    const navigate = useNavigate();
    useEffect(() => {
        loadAssignmentsByArea(9, setPersons, color, colorText);
    }, []);

    function useWindowWidth() {
        const [width, setWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return width;
    }
    const width = useWindowWidth();
    const isLess1000 = width < 1000;

    useEffect(() => {
        fetch(`/api/news/last_news/Basketball`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}${res}`);
                return res.json();
            })
            .then(data => {
                setArticle(data[0]);
            })
            .catch(err => {
                console.error("Fetch error:", err);

            });
    }, []);
    return (
        <section className={styles.container}>
            <h1>Basketball</h1>
            <div className={styles.top}>

                <section className={styles.persons}>
                    <h2 id='ansprechpartner'>Ansprechpartner</h2>
                    <div>
                        {persons.map((person) => (<PersonCard person={person}></PersonCard>))}
                    </div>
                </section>
                {!isLess1000 && (

                    <section>
                        <h2>Allgemeine Infos</h2>
                        <div className={styles.information}>
                            <p>Einst als Studenten-Sport erfunden, ist Basketball besonders bei Jugendlichen eine extrem beliebte Mannschaftssportart. Die Begeisterung für Dunkings und Dreier hat in der Region durch die magentafarbenen Bonner Riesen noch einmal großen Auftrieb bekommen.</p>
                            <p>Beim TuS erfreuen wir uns seit 2022 wieder über eine Jugendabteilung, in der 12- bis 16-jährige Mädchen und Jungen auf Korbjagd gehen.</p>
                            <p>Im Seniorenbereich hat der TuS im wahrsten Sinne des Wortes ebenfalls eine „Riesen-Truppe“.</p>
                        </div>
                    </section>

                )}

                <section className={styles.news}>
                    <h2>Letzte News</h2>
                    <div className={styles.newsInfo}>
                        {article ? (
                            <NewsCard data={article} />
                        ) : (
                            <NoNews></NoNews>
                        )}
                        <span onClick={() => navigate("/news")}>Weitere News hier...</span>
                    </div>
                </section>
                {isLess1000 && (
                    <section>
                        <h2>Allgemeine Infos</h2>
                        <div className={styles.information}>
                            <p>Einst als Studenten-Sport erfunden, ist Basketball besonders bei Jugendlichen eine extrem beliebte Mannschaftssportart. Die Begeisterung für Dunkings und Dreier hat in der Region durch die magentafarbenen Bonner Riesen noch einmal großen Auftrieb bekommen.</p>
                            <p>Beim TuS erfreuen wir uns seit 2022 wieder über eine Jugendabteilung, in der 12- bis 16-jährige Mädchen und Jungen auf Korbjagd gehen.</p>
                            <p>Im Seniorenbereich hat der TuS im wahrsten Sinne des Wortes ebenfalls eine „Riesen-Truppe“.</p>
                        </div>
                    </section>
                )}
            </div>

            <section id='Trainingszeiten' className={styles.trainingszeit}>
                <h2>Trainingszeiten</h2>
                <div>
                    <h3>Senioren</h3>
                    <div>
                        <table className={`${styles.table} ${styles.tableColor}`}>
                            <tr>
                                <td>Dienstag</td>
                                <td>19:30 - 22:00</td>
                                <td rowSpan="2" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <div className={styles.locationDiv}>
                                        <p>Ort: Realschule  Oberpleis Halle 2</p>
                                        <img src={`/assets/icons/google-map-icon.png`}
                                            alt="Realschule Sporthalle 2, Maps Link"
                                            onClick={() => window.open("https://g.co/kgs/yJG5u38", "_blank")}
                                            style={{ cursor: "pointer" }} />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Donnerstag</td>
                                <td>19:30 - 22:00</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </section>
            <section className={styles.unsereTeams}>
                <h2>Unsere Teams</h2>
                <div className={styles.spielplanTabelle}>
                    <div >
                        <div className={styles.teams}>
                            {basketballTeams.map((item, index) => (
                                <TeamCard key={index} item={item} />
                            ))}
                        </div>
                    </div>
                </div>
                <section>
                    <h3>Vorstellung</h3>
                    <div className={styles.vorstellung}>
                        <div><img className={styles.vorstellungImg} src='/images/mannschaftssport/basketball/Mannschaftsfoto_Herren_2024_basketball.jpg'
                            alt='Teamfoto, 1.Mannschaft Basketball, Oberpleis'></img></div>
                        <div className={styles.vorstellungList}>
                            <p>1. Mannschaft (Kreis Bonn)</p>
                            <ul>
                                <li>v.l.n.r
                                    {/* <ul>
                                        <li>Joshua Saal</li>
                                        <li>Niklas Neumann</li>
                                        <li>Mascha Strödke</li>
                                        <li>David Endter</li>
                                        <li>Hannah Becker</li>
                                        <li>Sebastian Strödke</li>
                                    </ul> */}
                                </li>
                                <li>es fehlen:
                                    {/* <ul>
                                        <li>Kristin Schönherr</li>
                                        <li>Philip Otzipka</li>
                                    </ul> */}
                                </li>
                            </ul>
                        </div>

                    </div>
                </section>
            </section>

        </section>
    )
}
export default Basketball;